import { BoxProps, ColorOptions, ModBox, Spacer, Text } from '@jfs/ui-new'
import XlsxPopulate from 'xlsx-populate'
import { List } from '../../components/List'
import { useStores } from '../../data/store'
import { isAccessible } from '../../utils'

const keyExtractor = (item: any): string => {
  return item.id
}
const headTitles = [{ id: 'Id' }, { status: 'Status' }, { mid: 'Merchant Id' }, { amount: 'Amount' }]
const listData = [
  { id: '1', status: 'On hold', mid: '100010000101', amount: '10' },
  { id: '2', status: 'Active', mid: '200020000122', amount: '1' },
]
const OnHoldSettlements = () => {
  const { accessConfig } = useStores((store) => ({
    accessConfig: store.user.getAccessConfig(['payout_config', 'fetch']),
  }))

  const exportFile = async (listData: any) => {
    let transformedData: any = []
    const filteredData = listData
    transformedData = filteredData.map((item: any) => [item?.id, item?.status, item?.mid, item?.amount])

    const inputKeys = ['id', 'status', 'mid', 'amount']

    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const data: any = []
      data.push([...inputKeys])

      filteredData.map((item: any, index: number) => {
        data.push([...Object.values(item), ...transformedData[index]])
      })

      workbook.sheet(0)?.cell('A1')?.value(data)

      const blob = await workbook.outputAsync({
        type: 'blob',
      })

      var url = window.URL.createObjectURL(blob as Blob)
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = 'dynamic_hold_settlements_file.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }

  return (
    <ModBox {...styles.container} show={isAccessible(accessConfig, 'fetch')}>
      <Text
        title={'View Dynamic Hold Settlements'}
        fontSize={28}
        fontWeight={'600'}
        color={'#5a5c69' as ColorOptions}
      />
      <Spacer size={24} direction="vertical" />
      <ModBox f={1}>
        <List
          keyExtractor={keyExtractor}
          headTitle={headTitles}
          numOfColumns={4}
          sizeConfig={[1, 2, 1, 1]}
          data={listData}
          listTitle={'Dynamic Hold Settlements'}
          isColumnSearchEnabled={false}
          exportFile={exportFile}
        />
      </ModBox>
    </ModBox>
  )
}

const styles = {
  container: {
    h: '100%',
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    p: 20,
    overflow: 'auto',
  } as BoxProps,
}

export default OnHoldSettlements
